type EyeDropperConstructor = new () => { open: () => Promise<{ sRGBHex: string }> };

export const getEyeDropper = (): EyeDropperConstructor | undefined =>
  typeof window === "undefined" ? undefined : (window as Window & { EyeDropper?: EyeDropperConstructor }).EyeDropper;
